import React, { useRef, useState } from 'react'
import { Alert, Box, Button, ButtonBase, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import SyncIcon from '@mui/icons-material/Sync'
import { sincronizarPedidos } from '../services/apis'

export const SincronizarPedidos = () => {
  const [abierto, setAbierto] = useState(false)
  const [sincronizando, setSincronizando] = useState(false)
  const [resultado, setResultado] = useState(null)
  const [error, setError] = useState('')
  const enCurso = useRef(false)

  const abrir = () => {
    setResultado(null)
    setError('')
    setAbierto(true)
  }

  const ejecutar = async () => {
    if (enCurso.current) return
    enCurso.current = true
    setSincronizando(true)
    setError('')
    try {
      setResultado(await sincronizarPedidos())
    } catch (err) {
      const mensaje = err.response?.data?.message
      setError(Array.isArray(mensaje) ? mensaje.join('. ') : mensaje || 'No se han podido sincronizar los pedidos. Intentalo de nuevo.')
    } finally {
      enCurso.current = false
      setSincronizando(false)
    }
  }

  return (
    <>
      <Grid
        component={ButtonBase}
        container
        direction="column"
        size={{ xs: 12, md: 12, lg: 4 }}
        className="card-main"
        onClick={abrir}
        disabled={sincronizando}
        sx={{ p: 2, alignItems: 'start', textAlign: 'left', color: 'inherit', '&:hover': { backgroundColor: '#FFFFFF' }, '&.Mui-focusVisible': { outline: '2px solid #F57C00', outlineOffset: 2 } }}
      >
        <SyncIcon color="primary" sx={{ fontSize: 55 }} />
        <Typography variant="h4">Sincronizar pedidos</Typography>
        <Typography variant="subtitle1">Business Central</Typography>
      </Grid>

      <Dialog open={abierto} onClose={sincronizando ? undefined : () => setAbierto(false)} fullWidth maxWidth="sm" aria-labelledby="sincronizar-pedidos-title">
        <DialogTitle id="sincronizar-pedidos-title">Sincronizar pedidos</DialogTitle>
        <DialogContent aria-busy={sincronizando}>
          {sincronizando ? (
            <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 2 }}>
              <CircularProgress size={24} />
              <Typography>Sincronizando pedidos con Business Central...</Typography>
            </Box>
          ) : resultado ? (
            <Box role="status">
              <Alert severity="success" sx={{ mb: 2 }}>Pedidos sincronizados correctamente.</Alert>
              {[
                ['Cabeceras', resultado.cabeceras],
                ['Lineas', resultado.lineas],
              ].map(([nombre, datos]) => (
                <Box key={nombre} sx={{ py: 1, borderBottom: '1px solid #E2E8F0' }}>
                  <Typography variant="subtitle2">{nombre}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Recibidas: {datos?.registrosRecibidos ?? 0} | Nuevas: {datos?.registrosCreados ?? 0} | Actualizadas: {datos?.registrosActualizados ?? 0}
                  </Typography>
                </Box>
              ))}
              <Typography variant="body2" sx={{ mt: 1.5 }}>
                Lineas marcadas como canceladas: {resultado.eliminadas?.registrosMarcadosEliminados ?? 0}
              </Typography>
            </Box>
          ) : (
            <>
              <Typography>Se actualizaran las cabeceras, lineas y cancelaciones de pedidos desde Business Central. La sincronizacion afecta a todos los almacenes.</Typography>
              {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            </>
          )}
        </DialogContent>
        <DialogActions>
          {!sincronizando && (
            <Button onClick={() => setAbierto(false)}>{resultado ? 'Cerrar' : 'Cancelar'}</Button>
          )}
          {!resultado && (
            <Button variant="contained" onClick={ejecutar} disabled={sincronizando} startIcon={sincronizando ? <CircularProgress size={16} color="inherit" /> : <SyncIcon />}>
              {sincronizando ? 'Sincronizando...' : error ? 'Reintentar' : 'Sincronizar'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  )
}
